<template>
  <div class="customer-list">
    <div class="fr ac jsb">
      我的客户
      <el-button size="mini" v-if="hasPermission(663)" @click="go('/register/applyCompany?type=1')"
      >添加客户
      </el-button>
    </div>

    <div class="mt30">
      <el-tabs v-model="tab" type="card" @tab-click="tabClick" v-if="$store.state.is_sales">
        <el-tab-pane label="近期下单客户" name="1"></el-tab-pane>
        <el-tab-pane label="直接客户" name="2"></el-tab-pane>
        <el-tab-pane label="间接客户" name="3"></el-tab-pane>
      </el-tabs>

      <!--      搜索 -->

      <div class="mt20 search" v-show="tab !== '1'">
        <el-input
            v-model="company_name"
            placeholder="请输入客户名称/联系人手机号/联系人搜索"
            clearable
            @clear="page = 1;getList();"
            size="small"
        ></el-input>
        <el-button size="mini" type="primary" @click="tabClick">搜索</el-button>
      </div>

      <!--      列表-->

      <el-descriptions v-for="item in customer_list"
                       :key="item.company_id" class="mt50" :title="item.company_name" :column="3" border>
        <template slot="extra">
          <el-button type="text" size="small" v-if="hasPermission(655)" @click="toUpdate(item)" icon="el-icon-edit">
            编辑资料
          </el-button>
          <el-button type="text" size="small" v-if="hasPermission(645)" @click="proxyCustomer(item)"
                     icon="el-icon-goods">代客下单
          </el-button>
        </template>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-user"></i>
            联系人
          </template>
          {{ item.contact_name }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-mobile-phone"></i>
            联系人电话
          </template>
          {{ item.contact_mobile }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-mobile-phone"></i>
            公司电话
          </template>
          {{ item.company_tel }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-office-building"></i>
            联系地址
          </template>
          {{
            item.company_province + item.company_city + item.company_country + item.company_address
          }}
        </el-descriptions-item>
      </el-descriptions>
      <el-empty v-if="customer_list.length === 0" description="暂无数据"></el-empty>


      <!--      分页-->
      <div class="fr jc ac mt50 mb50">
        <el-pagination
            :hide-on-single-page="true"
            background
            layout="prev, pager, next"
            :page-size="page_size"
            :current-page.sync="page"
            :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tab: "1",
      company_name: "",
      customer_list: [],
      page: 1,
      page_size: 24,
      total: 0,
      search: {
        time: "",
        start_time: "",
        end_time: "",
      },
    };
  },
  mounted() {
    if (!this.is_Empty(this.$store.state.instance)) {
      this.$store.state.instance.close();
      this.$store.commit("editInstance", null);
    }
    this.getList();
  },
  watch: {
    page(n) {
      this.getList();
    },
  },
  methods: {
    //切换tab
    tabClick() {
      this.page = 1;
      this.getList();
    },
    getList() {
      if (this.$store.state.is_sales) {
        if (this.tab === "1") {
          this.getRecentOrderCompanyList();
        } else if (this.tab === "2") {
          this.getSaleCompanyList();
        } else if (this.tab === "3") {
          this.getPlatformSalesCompanyList();
        }
      } else if (this.$store.state.is_part_time_sale) {
        this.getSaleCompanyList();
      }

    },
    //  获取最近下单用户
    getRecentOrderCompanyList() {
      let param = {
        start_time: "",
        end_time: this.conversion(new Date().getTime(), 222),
      };
      let day = 30; //有效期
      let date = day * 24 * 1000 * 60 * 60;
      let now = new Date().getTime();
      param.start_time = this.conversion(now - date, 222);
      this.post("saleInterfaces/v1.0/getRecentOrderCompanyList", param).then(
          (res) => {
            this.customer_list = res.data;
          }
      );
    },
    //  获取全部客户列表
    getSaleCompanyList() {
      let param = {
        higher_id: this.$store.state.memberInfo.member_id,
        search_key: this.company_name,
        page: this.page,
        pageSize: this.page_size,
      };
      this.post(this.$store.getters.getSaleCompanyList, param).then((res) => {
        this.customer_list = res.data;
        this.total = res.total;
      });
    },
    //  获取全部客户列表
    getPlatformSalesCompanyList() {
      let param = {
        higher_id: this.$store.state.memberInfo.member_id,
        search_key: this.company_name,
        page: this.page,
        pageSize: this.page_size,
      };
      this.post("saleInterfaces/v1.0/getPlatformSalesCompanyList", param).then(
          (res) => {
            this.customer_list = res.data;
            this.total = res.total;
          }
      );
    },
    //进入代客下单模式
    async proxyCustomer(item) {
      // 获取客户特殊要求列表
      let res = await this.post(
          "companyRequirement/getCompanyRequirementList",
          {
            company_id: item.company_id,
          }
      );
      let arr = [];
      res.data.forEach(el => {
        arr.push(`<p>${el.content}</p>`);
      })
      if (arr.length) {

        this.$alert(arr.join(' '), '客户特殊要求', {
          dangerouslyUseHTMLString: true
        }).then(res => {
          this.substitution(item.company_id);
        })
      } else {
        this.substitution(item.company_id);
      }

    },
    // 替换身份信息
    substitution(company_id) {
      this.$store.commit('setCurrentCompanyId', company_id);
      this.post("auth/salesProxyCompanyLogin", {
        company_id,
      }).then((res) => {
        let obj = this.$store.state.memberInfo;
        let permission_ids = this.$store.state.permission_ids;

        this.memberInfoInit(res.data);
        this.$store.commit("setSaleInfo", obj);
        this.$store.commit('setSalePermission_ids', permission_ids);
        this.go("/home/index");
      });
    },
    //去修改公司信息页面
    toUpdate(item) {
      this.$store.commit('setCompanyInfo', item)
      this.go(`/myCustomer/updateCustomer?company_id=${item.company_id}`)
      // this.$router.push({
      //   path: "/myCustomer/updateCustomer",
      //   query: {
      //     company_info: JSON.stringify(this.company_info),
      //   },
      // });
    },
  },
  components: {},
};
</script>

<style scoped lang="scss">
.customer-list {
  .search {
    width: 100%;
    display: grid;
    grid-template-columns: 300px 100px;
    grid-column-gap: 20px;

    .el-date-editor {
      width: 100%;
    }
  }

  .customer-list-box {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .item {
      width: 300px;
      height: 118px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(242, 242, 242, 1);
      box-shadow: 0 2px 4px rgba(65, 65, 65, 0.16);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/me/myCustomer/index.vue